import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgModule, HostListener} from '@angular/core';
import {AfterViewInit, ElementRef, ViewChild} from '@angular/core';
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  fulllist:any;
  name:any;
  defaultCounties:any = [{"name":"Central Office","value":9,"phone":"870-793-0666 or 1-855-506-2266","TDD":"N/A","address1":"1095 White Dr.","city":"Batesville","zip":72501}];
  selectedCounties:any=[{"name":"Central Office","value":9,"phone":"870-793-0666 or 1-855-506-2266","TDD":"N/A","address1":"1095 White Dr.","city":"Batesville","zip":72501}];
  countiesInfo:any=[];
  selectedProviders:any=[];
  selectedCounty:any = "Pick an Option";
  dropdownCounties:any = [];
  @ViewChild('tooltip') tooltip: ElementRef;
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e) {
    let x = e.clientX;
    let y = e.clientY;

    //Set tooltip position according to mouse position
    if(this.tooltip !== null && this.router.url == '/help'){
      this.tooltip.nativeElement.style.top = (y - 50) + 'px';
      this.tooltip.nativeElement.style.left = (x + 50) + 'px';
    }
    if(this.tooltip !== null && this.router.url == '/contact'){
      this.tooltip.nativeElement.style.top = (y - 120) + 'px';
      this.tooltip.nativeElement.style.left = (x - 400) + 'px';
    }
  }
  constructor(private http:HttpClient, public loginService:LoginService, public router:Router) { }

  ngOnInit() {
    this.http.get('../assets/data/codes.json').subscribe((data)=>{
      this.fulllist = data;
    })
    this.http.get('../assets/data/counties.json').subscribe((data)=>{
      this.countiesInfo = data;
    });
    this.selectedCounties.forEach((element)=>{
        let request = {county:element.value};
        this.loginService.getproviderInfo(request).subscribe((data:Array<Object>)=>{
          data.forEach((element)=>{
            let index = this.selectedProviders.findIndex(x=>x.provider_name == element["provider_name"]);
            if(index == -1){
              this.selectedProviders.push(element);
            }
          });
        })
    });
  }
   
  getName(event){
    this.name = this.fulllist[event.srcElement.classList[0]];
  }
  show(){
    this.selectedProviders = [];
    this.selectedCounties = [];
    this.dropdownCounties = [];
    let index = this.countiesInfo.findIndex(x=>x.value == this.selectedCounty);
    this.selectedCounties.push(this.defaultCounties[0]);
    this.selectedCounties.push(this.countiesInfo[index]);
    this.dropdownCounties.push(this.countiesInfo[index]);
    let request = {county:this.selectedCounty};
    this.loginService.getproviderInfo(request).subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        let index = this.selectedProviders.findIndex(x=>x.provider_name == element["provider_name"]);
        if(index == -1){
          this.selectedProviders.push(element);
        }
      });
    });
    const elementList = $(".select");
    if(elementList.length >0){
      for(let i=0; i<= elementList.length; i++){
        if(elementList[i] != undefined){
          elementList[i].classList.remove("select");
        }
      }
    }
  }
  select(event){
    if(event.srcElement.classList[1] == undefined){
      this.selectedCounty = "Pick an Option";
      if(this.dropdownCounties.length > 0){
        let value = this.dropdownCounties[0].value;
        this.selectedCounties = this.selectedCounties.filter(function( obj ) {
          return obj.value !== value;
        });
      }
      event.srcElement.classList.add("select");
      this.countiesInfo.forEach((element)=>{
        if(element.name == this.name){
          this.selectedCounties.push(element);
          let request = {county:element.value};
          this.loginService.getproviderInfo(request).subscribe((data:Array<Object>)=>{
            data.forEach((element)=>{
              let index = this.selectedProviders.findIndex(x=>x.provider_name == element["provider_name"]);
              if(index == -1){
                this.selectedProviders.push(element);
              }
            });
          })
        }
      });
    }
    else{
      this.selectedCounty = "Pick an Option";
      event.srcElement.classList.remove("select");
      this.selectedProviders = [];
      this.selectedCounties = this.selectedCounties.filter((element)=>{
        if(element.name != this.name){
          let request = {county:element.value};
          this.loginService.getproviderInfo(request).subscribe((data:Array<Object>)=>{
            data.forEach((element)=>{
              let index = this.selectedProviders.findIndex(x=>x.provider_name == element["provider_name"]);
              if(index == -1){
                this.selectedProviders.push(element);
              }
            });
          })
          return element;
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/map/map.component.ts